/* ==========================================================================
   TØTE — collection page split test round (C01–C18) behaviour
   Kopstorm CommV

   C02  Offer strip countdown. Fixed end date or daily reset, hides itself
        after a fixed deadline passes.
   C17  Sticky sort and filter bar. Computes the sticky header offset and
        toggles a shadow class while the bar is stuck.
   C18  Bestseller default sorting. Applies sort_by=best-selling through the
        theme facet form (AJAX rerender by facets.js) when the visitor has
        not chosen a sort order. Exposed as window.kvApplyDefaultSort for
        Intelligems variant JS.

   Gate aware: behaviour modifiers (C16, C17, C18) ship with a per test
   gate class (kv-mod-off-c16, kv-mod-off-c17, kv-mod-off-c18) on the
   storefront and only activate once the gate is lifted. In the theme
   editor the classes are omitted so everything is visible. Intelligems
   lifts a gate either by removing the class or, recommended, by adding
   kv-c17 / kv-c18 to the html element (survives facet AJAX rerenders).
   A MutationObserver reacts to both after page load.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__kvCollectionTestsInit) return;
  window.__kvCollectionTestsInit = true;

  /* ---- C02 · Countdown --------------------------------------------------- */
  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function initCountdown(root) {
    if (root.__kvCountdown) return;
    root.__kvCountdown = true;

    var mode = root.getAttribute('data-kv-countdown-mode') || 'daily';
    var endAttr = root.getAttribute('data-kv-countdown-end') || '';
    var dEl = root.querySelector('[data-kv-cd-days]');
    var hEl = root.querySelector('[data-kv-cd-hours]');
    var mEl = root.querySelector('[data-kv-cd-mins]');
    var sEl = root.querySelector('[data-kv-cd-secs]');
    if (!hEl || !mEl || !sEl) return;

    function target() {
      if (mode === 'fixed' && endAttr) {
        var t = new Date(endAttr.replace(' ', 'T'));
        return isNaN(t.getTime()) ? null : t;
      }
      /* Daily mode: counts down to local midnight, restarts every day. */
      var d = new Date();
      d.setHours(24, 0, 0, 0);
      return d;
    }

    function tick() {
      var end = target();
      if (!end) return;
      var diff = end.getTime() - Date.now();
      if (diff <= 0) {
        if (mode === 'fixed') {
          root.classList.add('kv-cc-offer--expired');
          window.clearInterval(root.__kvCountdownTimer);
          return;
        }
        diff = 0;
      }
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var secs = Math.floor((diff % 60000) / 1000);
      if (dEl) {
        dEl.textContent = pad(days);
        var dayUnit = dEl.closest('.kv-cc-offer__unit');
        if (dayUnit) dayUnit.style.display = days > 0 ? '' : 'none';
      } else {
        hours = hours + days * 24;
      }
      hEl.textContent = pad(hours);
      mEl.textContent = pad(mins);
      sEl.textContent = pad(secs);
    }

    tick();
    root.__kvCountdownTimer = window.setInterval(tick, 1000);
  }

  /* ---- C17 · Sticky facets bar ------------------------------------------- */
  function initSticky(bar) {
    if (bar.__kvSticky) return;
    bar.__kvSticky = true;

    function setOffset() {
      var header = document.querySelector('.shopify-section-header-sticky');
      var offset = 0;
      if (header) {
        var type = header.querySelector('.header-wrapper[data-sticky-type]');
        var stickyType = type ? type.getAttribute('data-sticky-type') : '';
        if (stickyType !== 'on-scroll-up' && stickyType !== 'none') {
          offset = header.offsetHeight;
        }
      }
      bar.style.setProperty('--kv-cc-sticky-top', offset + 'px');
    }

    setOffset();
    window.addEventListener('resize', setOffset);

    /* Shadow while stuck: a 1px sentinel right above the bar leaves the
       viewport exactly when the bar starts sticking. */
    if ('IntersectionObserver' in window && bar.parentNode) {
      var sentinel = document.createElement('div');
      sentinel.setAttribute('aria-hidden', 'true');
      sentinel.style.cssText = 'position:relative;height:1px;margin-top:-1px;pointer-events:none;';
      bar.parentNode.insertBefore(sentinel, bar);
      new IntersectionObserver(
        function (entries) {
          bar.classList.toggle('kv-cc-is-stuck', !entries[0].isIntersecting);
        },
        { rootMargin: '-2px 0px 0px 0px' }
      ).observe(sentinel);
    }
  }

  /* ---- C18 · Bestseller default sorting ----------------------------------- */
  function c18Enabled(grid) {
    if (document.documentElement.classList.contains('kv-c18')) return true;
    return !grid.classList.contains('kv-mod-off-c18');
  }

  function applyDefaultSort(force) {
    var grid = document.querySelector('[data-kv-default-sort]');
    if (!grid) return;
    if (!force && !c18Enabled(grid)) return;
    if (window.__kvSortApplied) return;

    var sortValue = grid.getAttribute('data-kv-default-sort');
    if (!sortValue) return;
    if (/[?&]sort_by=/.test(window.location.search)) return;

    var selects = document.querySelectorAll('select[name="sort_by"]');
    if (!selects.length) return;
    window.__kvSortApplied = true;

    var select = selects[0];
    if (select.value === sortValue) return;
    var hasOption = Array.prototype.some.call(select.options, function (o) {
      return o.value === sortValue;
    });
    if (!hasOption) return;
    select.value = sortValue;
    /* facets.js listens for input on the facet form and rerenders the grid
       over AJAX, so this behaves exactly like a visitor picking the order. */
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }
  window.kvApplyDefaultSort = function () {
    applyDefaultSort(true);
  };

  /* ---- Boot ---------------------------------------------------------------- */
  function stickyBars() {
    var html = document.documentElement;
    return Array.prototype.filter.call(
      document.querySelectorAll('.kv-cc-facets-sticky'),
      function (bar) {
        return (
          html.classList.contains('kv-c17') ||
          !bar.classList.contains('kv-mod-off-c17')
        );
      }
    );
  }

  function boot() {
    document.querySelectorAll('[data-kv-countdown]').forEach(initCountdown);
    stickyBars().forEach(initSticky);
    applyDefaultSort(false);
  }

  /* React when Intelligems lifts a gate after page load, either on the
     element itself or through the html level kv-c17 / kv-c18 classes. */
  function watchGates() {
    if (!('MutationObserver' in window)) return;
    var observer = new MutationObserver(function () {
      stickyBars().forEach(initSticky);
      applyDefaultSort(false);
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });
    document
      .querySelectorAll('[class*="kv-mod-off"]')
      .forEach(function (el) {
        observer.observe(el, { attributes: true, attributeFilter: ['class'] });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
      watchGates();
    });
  } else {
    boot();
    watchGates();
  }
})();
